<div
  class="search-filter-hierarchy"
  [ngClass]="{'sideMenu': sideMenu, 'dropdownMenu': !sideMenu}"
>
  <ul class="search-filter-hierarchy__items">
    @for (child of getChildNodes(); track $index) {
      <li class="search-filter-hierarchy__item">
        <div class="search-filter-hierarchy__item-content filter-checkbox">
          @if (child.childrenArray.length) {
            <ng-container>
              <a
                class="node-width-children"
                (click)="toggleOpen(child)"
                [ngClass]="{'open': child.open}"
              >
                <mat-icon
                  class="hierarchic-arrow-white"
                  [class.black]="newFilterMenu"
                  [ngClass]="{'selected': child.facet.selected}"
                >
                  arrow_right
                </mat-icon>
              </a>
            </ng-container>
          }

          <span
            (click)="select(child)"
            (keydown)="null"
          >
            <span
              class="search-filter-hierarchy__item-text"
              [ngClass]="{'bold selected': child.facet.selected}"
            >
              <span
                [class.black]="newFilterMenu"
                class="search-filter-hierarchy__item-text-content" [innerHTML]="child.facet.shortName"></span>

              <span class="search-filter-hierarchy__countText">
                ({{child.facet.count}})
              </span>
            </span>
          </span>
        </div>

        @if (child.open) {
          <app-search-filter-hierarchy
            [node]="child"
            [searchContainer]="searchContainer"
          ></app-search-filter-hierarchy>
        }
      </li>
    }
  </ul>
</div>
